import React from 'react';

const LinearActuators = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 50.089 85.573"
			className={className}
		>
			<g fill="currentColor">
				<path d="M15.771 65.273h-2.549v20.3h23.644v-20.3h-2.549V27.964h4.708V0H11.061v27.964h4.708v37.309Zm3.494 0v-.479l11.561-6.166v6.645Zm11.561-9.021-11.561 6.166V56.04l11.561-6.166Zm0-8.759-11.561 6.166v-6.383l11.561-6.166Zm0-8.759L19.265 44.9v-6.383l11.561-6.166ZM16.711 68.765h16.656v13.313H16.711ZM30.82 29.976 19.264 36.14v-8.181h11.561Zm-16.268-5.508V3.492h20.976v20.976Z" />
				<path d="M2.645 61.03h1.4v-25.9h2.646l-3.345-5.793L.003 35.13h2.645Z" />
				<path d="m46.745 61.03 3.343-5.793h-2.645v-25.9h-1.4v25.9H43.4Z" />
				<path d="M17.904 5.877a.99.99 0 1 0 .7.29.988.988 0 0 0-.7-.29Z" />
				<path d="M17.904 20.038a.99.99 0 1 0 .7.29.988.988 0 0 0-.7-.29Z" />
				<path d="M32.136 5.877a.99.99 0 1 0 .7.29.988.988 0 0 0-.7-.29Z" />
				<path d="M32.136 20.038a.99.99 0 1 0 .7.29.988.988 0 0 0-.7-.29Z" />
			</g>
		</svg>
	);
};

export default LinearActuators;
